import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TopLevelComponent } from './components/top-level/top-level.component';


const routes: Routes =
[
  {
    path: '',
    component: TopLevelComponent,
    children: [
      {
        path: 'mobile',
        loadChildren: () => import('./main/mobile/mobile.module').then( (m) => m.MobileModule )
      },
      {
        path : "",
        loadChildren : () => import("./main/desktop/desktop.module").then((m)=>m.DesktopModule),
      },
      {
        path: "theme",
        loadChildren: ()=> import('./themes/themes-categories.module').then( (m)=> m.AllThemesModule )
      },
      {
        path: "**",
        redirectTo: "home"
      }
    ]
  }
];


@NgModule({
  imports: [RouterModule.forRoot(routes , { scrollPositionRestoration : "top" })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
